const strings = {
  title: 'Dados da Equipe',
  titleEndereco: 'Endereço',
  document: 'CPF/CNPJ',
  email: 'Email',
  celular: 'Celular',
  situacao: 'Situacao',
  cadastro: 'Cadastrado em: ',
  addUser: 'Adicionar',
}

export default strings
